export default __webpack_public_path__ + "static/media/cordoba capital.416a8041.svg";